import React from 'react';

const UserAvatarIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#001C3D"
      fillOpacity="0.08"
    />
    <path
      d="M14.75 9.25C14.75 7.73063 13.5194 6.5 12 6.5C10.4806 6.5 9.25 7.73063 9.25 9.25C9.25 10.7694 10.4806 12 12 12C13.5194 12 14.75 10.7694 14.75 9.25ZM6.5 16.1154V16.83C6.5 17.2 6.79997 17.5 7.17 17.5H16.83C17.2 17.5 17.5 17.2 17.5 16.83V16.1154C17.5 13.6923 13.8356 13 12 13C10.1644 13 6.5 13.6923 6.5 16.1154Z"
      fill="#AEB7C2"
    />
  </svg>
);

export default UserAvatarIcon;
